const state = {
    currentRow:{}
}

const mutations = {
    setCurrentRow(state,{row}){
        state.currentRow = row
    }
}
const actions = {}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
  